<style>
.page-item{
        cursor:pointer;
}
.skeleton-line {
  height: 14px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #dddddd 37%,
    #eeeeee 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.text-muted i {
  color: #999;
}

</style>

<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Daftar Barang Keluar</h3>
            </div>  
        </div>
        <!--<div class="row">
            <div class="col-12" style="padding-bottom:10px;">
                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Barang Keluar
                </button>
            </div>
        </div>-->

		<!-- TOOLBAR FILTER TAHUN (DI ATAS CARD) -->
		<div class="d-flex justify-content-between align-items-center mb-2">

		  <!-- KIRI (opsional, biar sejajar tombol saldo awal) -->
		  <div>
			  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Barang Keluar
                </button>
			</div>

		  <!-- KANAN (ABSOLUTE) -->
		  <div class="d-flex align-items-center">	
			
			<!-- SUMBER DANA -->
			  <label class="mr-2 font-weight-bold mb-0">Sumber Dana</label>
			  <select
				v-model="filterSumberDana"
				class="form-control form-control-sm mr-3"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Semua</option>
				<option
				  v-for="sd in sumberdanas"
				  :key="sd.id"
				  :value="sd.id"
				>
				  {{ sd.nama }}
				</option>
			  </select>
			  
			  <label class="mr-2 font-weight-bold mb-0">Tahun</label>
			  <select
				v-model="tahunBarangKeluar"
				class="form-control form-control-sm"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Pilih</option>
				<option v-for="t in listTahunBarangKeluar" :key="t" :value="t">
				  {{ t }}
				</option>
			  </select>
			</div>


		</div>
		
		<!-- TABEL -->

        <div class="row">
          <div class="col-12">
            <div class="card">
                <div class="card-header">
                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>

              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th role='button' v-on:click="sortRecords('id', 'barang_keluar')">ID</th>
                      <th role='button' v-on:click="sortRecords('tanggal_keluar', 'barang_keluar')">Tanggal Keluar</th>
                      <th role='button' v-on:click="sortRecords('nama', 'sumber_dana')">Sumber Dana</th>
                      <th role='button' v-on:click="sortRecords('nama', 'ruang')">Ruang</th>
                      <!--<th class="text-right">Sub Total</th>-->
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
						<!-- SKELETON -->
					<template v-if="isLoadingTable">
						<tr v-for="n in 5" :key="'sk-'+n">
						  <td colspan="10">
							<div class="skeleton-line"></div>
						  </td>
						</tr>
					</template>

					<!-- BELUM PILIH TAHUN -->
					<tr v-else-if="!tahunBarangKeluar">
						<td colspan="10" class="text-center text-muted py-4">
						  Silakan pilih tahun untuk menampilkan data
						</td>
					</tr>

					<!-- DATA KOSONG -->
					<tr v-else-if="isDataKosong">
						<td colspan="10" class="text-center text-muted py-4">
						  <i class="fa fa-info-circle mr-1"></i>
						  Belum ada transaksi barang keluar pada tahun
						  <strong>{{ tahunBarangKeluar }}</strong>
						</td>
					</tr>
					
                     <tr v-for="barangkeluar in barangkeluars.data" :key="barangkeluar.id" @click="previewBarangKeluar(barangkeluar)">

                      <td>{{barangkeluar.id}}</td>
                      <td class="text-capitalize">{{barangkeluar.tanggal_keluar}}</td>
                      <td>{{barangkeluar.nama_sumber_dana}}</td>
                      <td>{{barangkeluar.nama_ruang}}</td>
                     <!-- <td class="text-right">{{ formatRupiah(barangkeluar.sub_total) }}</td>-->
                      <td>

                        <!--<router-link :to='"/detail_barang_keluar?barang_keluar_id=" + barangkeluar.id + "&status_kunci=" + barangkeluar.selisih'>
                                <i class="nav-icon fas fa-list-ul red"></i>
                            </router-link>-->
							
						<router-link @click.stop :to="{path: '/detail_barang_keluar', query: {barang_keluar_id: barangkeluar.id, tahun: tahunBarangKeluar}}">
									<i class="nav-icon fas fa-list-ul red"></i>
								</router-link>
								
                         &nbsp;
                         <a v-if="barangkeluar.selisih >= '0'" href="#" @click.stop="editModal(barangkeluar, barangkeluar.selisih)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        &nbsp;
                        <a v-if="barangkeluar.selisih >= '0'" href="#" @click.stop="deleteData(barangkeluar.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                    <!--<tr v-if="barangkeluars && barangkeluars.data && barangkeluars.data.length">
                      <th colspan="4" class="text-right">Grand Total</th>
                      <th class="text-right">{{ formatRupiah(grandTotalKeseluruhan) }}</th>
                      <th></th>
                    </tr>-->
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <div class="row">                  
                        <div class="col-12">
                            <pagination :records="parseInt(barangkeluars.total)" v-model="page" :per-page="perPage" :options="{texts: { count: 'Menampilkan data ke {from} sampai {to} dari total {count} data|{count} records|One record' }}" @paginate="getResults"></pagination>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-12">
                                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                        </div>
                    </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

		<!-- MODAL PREVIEW BARANG KELUAR -->
		<div class="modal fade" id="modalPreviewBarangKeluar" tabindex="-1">
		  <div class="modal-dialog modal-xl">
			<div class="modal-content">

			  <div class="modal-header">
				<h5 class="modal-title">Preview Detail Barang Keluar</h5>
				<button type="button" class="close" @click="tutupModalPreview">
				  <span>&times;</span>
				</button>
			  </div>

			  <div class="modal-body">
				<table class="table table-sm table-bordered">
				  <thead>
					<tr>
					  <th>Barang</th>
					  <th>Keterangan</th>
					  <th>Satuan</th>
					  <th>Qty</th>
                      <!--<th class="text-right">Harga Satuan</th>-->
                      <!--<th class="text-right">Sub Total</th>-->
					</tr>
				  </thead>
				  <tbody>
					<tr v-if="loadingPreview">
					  <td colspan="4" class="text-center">
						<i class="fa fa-spinner fa-spin"></i> Loading...
					  </td>
					</tr>

					<tr v-for="d in previewDetails" :key="d.id">
					  <td>{{ d.nama_barang }}</td>
					  <td>{{ d.keterangan }}</td>
					  <td>{{ d.nama_satuan }}</td>
					  <td class="text-right">{{ d.qty }}</td>
                      <!--<td class="text-right">{{ formatRupiah(d.harga_satuan) }}</td>-->
                      <!--<td class="text-right">{{ formatRupiah(d.sub_total) }}</td>-->
					</tr>
				  </tbody>
                  <!--<tfoot>
                    <tr>
                      <th colspan="5" class="text-right">Grand Total</th>
                      <th class="text-right">{{ formatRupiah(previewGrandTotal) }}</th>
                    </tr>
                  </tfoot>-->
				</table>
			  </div>

			  <div class="modal-footer">
				<button class="btn btn-secondary" @click="tutupModalPreview">
				  Tutup
				</button>
				<button class="btn btn-primary" @click="goToDetailBarangKeluar(previewHeader.id)">
				  Lihat Detail / Edit
				</button>
			  </div>

			</div>
		  </div>
		</div>

		<!---------- -->

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Barang Keluar</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Barang Keluar</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateBarangKeluar() : createBarangKeluar()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal Keluar</label>
                            <datepicker v-model="form.tanggal_keluar" :disabledDates="disabledAkhir" :format="format"  name="tanggal_keluar" class="form-controlx" :class="{ 'is-invalid': form.errors.has('tanggal_keluar') }"></datepicker>
                            <has-error :form="form" field="tanggal_keluar"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Sumber Dana</label>
                            <select v-model="form.sumber_dana_id" name="sumber_dana_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Sumber Dana') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="sumberdana in sumberdanas" :value="sumberdana.id">
                                {{ sumberdana.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="sumber_dana_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Unit Kerja</label>
                            <select v-model="form.unit_kerja_id" name="unit_kerja_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Unit Kerja') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="unitkerja in unitkerjas" :value="unitkerja.id">
                                {{ unitkerja.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="unit_kerja_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Ruang</label>
                            <select v-model="form.ruang_id" name="ruang_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Ruang') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="ruang in ruangs" :value="ruang.id">
                                {{ ruang.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="ruang_id"></has-error>
                        </div>
                    </div>
                   
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" v-if="statusKunci == false" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Pagination from 'vue-pagination-2';

    export default {
        components: {
            Pagination,
            Datepicker
        },
        data () {
            return {
                editmode: false,
                searchTerm:'',
                statusKunci: false,
                barangkeluars : {},
                grandTotalKeseluruhan: 0,
                unitkerjas : {},
                sumberdanas : {},
                ruangs : {},
                format: 'yyyy-MM-dd',
                akhir:'',
                 tanggalKunci:'',
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                form: new Form({
                    id : '',      
                    tanggal_keluar: '',
                    unit_kerja_id: '',
                    sumber_dana_id: '',
                    ruang_id: ''
                }),
                sortIndex: 'tanggal_keluar',
                sortDirection: 'desc',
                perPage:10,
                showTable:'barang_keluar',
                page: 1,
				tahunBarangKeluar: this.$route.query.tahun ? parseInt(this.$route.query.tahun) : new Date().getFullYear(),
				listTahunBarangKeluar: [],
				isLoadingTable: false, // ⬅️ untuk skeleton
				filterSumberDana: '',
				showPreviewModal: false,
				loadingPreview: false,
				previewHeader: {},
				previewDetails: [],
                previewGrandTotal: 0,
            }
        },
		
		computed: {			
			isDataKosong() {
				return (
				  !this.isLoadingTable &&
				  this.tahunBarangKeluar &&
				  this.barangkeluars?.data &&
				  this.barangkeluars.data.length === 0
				)
			  }
		},
		
        methods: {
            formatRupiah(value) {
                return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 2 }).format(Number(value) || 0)
            },
			previewBarangKeluar(item) {
			  this.loadingPreview = true
			  this.previewHeader = item
			  this.previewDetails = []
				
				$('#modalPreviewBarangKeluar').modal('show')
				
			  axios.get('/api/barang_keluar/' + item.id + '/preview')
				.then(res => {
				  this.previewDetails = res.data.data.details
                  this.previewGrandTotal = res.data.data.grand_total || 0
				})
				.finally(() => {
				  this.loadingPreview = false
				})
			},
			
			goToDetailBarangKeluar(id) {
			  this.$router.push({
				path: '/detail_barang_keluar',
				query: {
				  barang_keluar_id: id,
				  tahun: this.tahunBarangKeluar
				}
			  })
			  $('#modalPreviewBarangKeluar').modal('hide');
			},
			
			tutupModalPreview() {
				$('#modalPreviewBarangKeluar').modal('hide');
			},
			
            sortRecords (index, tableName) {
               
                /*this.sortIndex = index;
                this.showTable = tableName;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                
                this.page = 1;
                axios.get('/api/barang_keluar?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangkeluars = data.data.barang_keluar, this.sumberdanas = data.data.sumber_dana, this.ruangs = data.data.ruang, this.unitkerjas = data.data.unit_kerja));


                this.$Progress.finish();*/
				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){
                /*this.$Progress.start();
                  this.page = 1;

                    axios.get('/api/barang_keluar?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangkeluars = data.data.barang_keluar, this.sumberdanas = data.data.sumber_dana, this.ruangs = data.data.ruang, this.unitkerjas = data.data.unit_kerja));

                  this.$Progress.finish();*/
				  
				this.page = 1
				this.getResults(1) 
            },

            getResults(page = 1) {

                  /*this.$Progress.start();
                  
                  axios.get('/api/barang_keluar?page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangkeluars = data.data.barang_keluar, this.sumberdanas = data.data.sumber_dana, this.ruangs = data.data.ruang, this.unitkerjas = data.data.unit_kerja));

                  this.$Progress.finish();*/
				  
				  // ⛔ jangan load data kalau tahun belum dipilih
				  if (!this.tahunBarangKeluar) {
					this.barangkeluars = { data: [], total: 0 }
                    this.grandTotalKeseluruhan = 0
					return
				  }

					this.isLoadingTable = true
				  this.$Progress.start()

				  axios.get('/api/barang_keluar', {
					params: {
					  page: page,
					  tahun: this.tahunBarangKeluar,
					  sumber_dana_id: this.filterSumberDana,
					  sortIndex: this.sortIndex,
					  sortDirection: this.sortDirection,
					  showPage: this.perPage,
					  showTable: this.showTable
					}
				  }).then(({ data }) => {
					this.barangkeluars = data.data.barang_keluar
                    this.grandTotalKeseluruhan = Number(data.data.grand_total) || 0
					this.sumberdanas  = data.data.sumber_dana
					this.unitkerjas   = data.data.unit_kerja
					this.ruangs    = data.data.ruang
				  }).finally(() => {
					this.isLoadingTable = false
					this.$Progress.finish()
				  })
            },
            updateBarangKeluar(){
                this.$Progress.start();
                this.form.put('/api/barang_keluar/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadBarangKeluars();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/barang_keluar/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },
            editModal(barang_keluar, selisih){
                this.tanggalKunci = new Date(this.unitkerjas[0].tanggal_kunci);
                this.disabledAkhir = {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(1900, 1, 31),
                        to: new Date(this.tanggalKunci.getFullYear(), this.tanggalKunci.getMonth(), this.tanggalKunci.getDate())
                    }]
                };

                if(parseFloat(selisih) >= 0){
                    this.statusKunci = false;
                }else{
                     this.statusKunci = true;
                }

                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(barang_keluar);
            },
            newModal(){
                this.tanggalKunci = new Date(this.unitkerjas[0].tanggal_kunci);
                this.disabledAkhir = {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(1900, 1, 31),
                        to: new Date(this.tanggalKunci.getFullYear(), this.tanggalKunci.getMonth(), this.tanggalKunci.getDate())
                    }]
                };

                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadBarangKeluars(){
                /*this.$Progress.start();

                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;

                axios.get("/api/barang_keluar?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangkeluars = data.data.barang_keluar, this.sumberdanas = data.data.sumber_dana, this.ruangs = data.data.ruang, this.unitkerjas = data.data.unit_kerja));

                this.$Progress.finish();*/
				
				if (!this.tahunBarangKeluar) {
					this.barangkeluars = {}
					return
				}

				this.$Progress.start()

				let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm

				axios.get("/api/barang_keluar", {
					params: {
						search: param,
						tahun: this.tahunBarangKeluar,
						sumber_dana_id: this.filterSumberDana,
						sortIndex: this.sortIndex,
						sortDirection: this.sortDirection,
						showPage: this.perPage,
						showTable: this.showTable
					}
				}).then(({ data }) => {
					this.barangkeluars = data.data.barang_keluar
                    this.grandTotalKeseluruhan = Number(data.data.grand_total) || 0
					this.sumberdanas = data.data.sumber_dana
					this.unitkerjas = data.data.unit_kerja
					this.ruangs = data.data.ruang
				})

				this.$Progress.finish()
            },
            
            createBarangKeluar(){

                this.form.post('/api/barang_keluar')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadBarangKeluars();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            //this.loadBarangKeluars();
			const now = new Date().getFullYear()
			for (let i = 0; i < 2; i++) {
				this.listTahunBarangKeluar.push(now - i)
			}
			// ⬅️ langsung load data tahun berjalan
			this.getResults(1)
            this.$Progress.finish();

        },
        watch: {
			'$route.query.tahun'(val) {
				this.tahunBarangKeluar = val
				  ? parseInt(val)
				  : new Date().getFullYear()
				
				this.page = 1
				this.getResults(1)
			  }, 
            searchTerm: function() {
                this.loadBarangKeluars();
            },
			filterSumberDana() {
				this.page = 1
				this.getResults(1)
			  }
        }
    }
</script>